export const SET_CASHIER_LIST = 'SET_CASHIER_LIST'
